export var AgentDataFields;
(function (AgentDataFields) {
    AgentDataFields["JOB_TITLE"] = "jobTitle";
    AgentDataFields["MANAGER_ID"] = "managerId";
    AgentDataFields["LOCATION_ID"] = "locationId";
    AgentDataFields["TEAM_ID"] = "teamId";
    AgentDataFields["LOCALES"] = "locales";
    AgentDataFields["QUALIFIED_CHANNELS"] = "qualifiedChannels";
    AgentDataFields["ACTIVE"] = "active";
    AgentDataFields["INTERFACE_LOCALE"] = "interfaceLocale";
})(AgentDataFields || (AgentDataFields = {}));
//# sourceMappingURL=agent-data-fields.enum.js.map